import { Switch } from "~/ui";

type Props = {
  canEdit: boolean;
  createModalLabel: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

/** Org toggle for the typed-signature create-modal field. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const DocumentTypedSignatureSettingsField = ({ canEdit, createModalLabel, checked, onChange }: Props) => (
  <Switch
    label={`Allow typed signature on ${createModalLabel}`}
    description="When enabled, brokers can type a name that prints in a signature-style font on the PDF."
    disabled={!canEdit}
    checked={checked}
    onChange={event => onChange(event.currentTarget.checked)}
  />
);
